module.exports = __webpack_public_path__ + "static/media/tower.75de2326.svg";